import type { Appointment, EpisodeOfCare } from "@rmh/defs";
import { AppointmentType } from "@rmh/defs";

interface TranslationFunctions {
  tBodyRegions: (key: string) => string;
  tAppointmentCard: (key: string) => string;
}

export const getAppointmentTitle = (
  eoc: EpisodeOfCare,
  appointment?: Appointment,
  translations?: TranslationFunctions
) => {
  const bodyRegionKey = eoc.incident?.affectedBodyRegion.bodyRegion;
  const bodyPart = translations?.tBodyRegions 
    ? translations.tBodyRegions(bodyRegionKey ?? "")
    : bodyRegionKey?.replaceAll("_", " ");

  const appointmentType =
    appointment?.appointmentType === AppointmentType.Triage
      ? (translations?.tAppointmentCard("assessment") ?? "Assessment")
      : (translations?.tAppointmentCard("followup") ?? "Followup");

  return `${bodyPart} ${appointmentType}`;
};
